import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {ThesisOverviewComponent} from './thesis-overview.component';

const routes: Routes = [
  {path: 'theses', component: ThesisOverviewComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class ThesisOverviewRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/thesis/thesis-overview/thesis-overview-routing.module.ts